export class PriceCatalogApprovalDto {
    id = 0;
    priceCatalogId = 0;
    isAlreadyApproved = false;
  }
  